import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class UnityService extends BaseAPIClass {
  baseUrl = '';
  public isLoading = false;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/unidades';
  }
}
